export default {"src":"/_next/static/media/Brown.c1e955cc.svg","height":112,"width":66,"blurWidth":0,"blurHeight":0};